module.exports = __webpack_public_path__ + "assets/f8f3f5e6cbae066970cc4879ce3e6066.mp3";